module.exports = __webpack_public_path__ + "static/img/something_wrong.38af8656.png";